// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Links_pageContainer__jCNjv {
  min-height: 100vh;
  background-color: #1F1D1D;
  color: #fff;
  font-family: 'Manrope', sans-serif;
}

.Links_headerSection__8evuI {
  width: 100%;
  background-color: #1F1D1D;
  position: sticky;
  top: 0;
  z-index: 10;
}

.Links_headerContent__WelKd {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 2rem 0;
}

.Links_headerTop__CunUv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.Links_backButton__rweU- {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  border-radius: 8px;
  color: #fff;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Manrope', sans-serif;
  width: fit-content;
}

.Links_backButton__rweU-:hover {
  background: rgba(255, 255, 255, 0.1);
}

.Links_title__SlbNS {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
}

.Links_mainContainer__VeVwH {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 2rem;
}

.Links_grid__-hrzq {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.Links_card__ww32g {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
  animation: Links_fadeInUp__FmB9U 0.5s ease forwards;
}

@keyframes Links_fadeInUp__FmB9U {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Links_grid__-hrzq > *:nth-child(1) { animation-delay: 0.1s; }
.Links_grid__-hrzq > *:nth-child(2) { animation-delay: 0.2s; }
.Links_grid__-hrzq > *:nth-child(3) { animation-delay: 0.3s; }
.Links_grid__-hrzq > *:nth-child(4) { animation-delay: 0.4s; }
.Links_grid__-hrzq > *:nth-child(5) { animation-delay: 0.5s; }

.Links_cardHeader__6QeYk {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.Links_icon__kKFo4 {
  color: #E50000;
}

.Links_platformName__RI7TU {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.Links_url__NCx-V {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.9rem;
  word-break: break-all;
}

.Links_url__NCx-V:hover {
  color: #fff;
}

.Links_cardActions__C4t7S {
  display: flex;
  gap: 0.75rem;
  margin-top: auto;
}

.Links_editButton__Hpdyp,
.Links_resetButton__LcYuY {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-family: 'Manrope', sans-serif;
  transition: all 0.2s ease;
}

.Links_editButton__Hpdyp {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.Links_editButton__Hpdyp:hover {
  background: rgba(255, 255, 255, 0.1);
}

.Links_resetButton__LcYuY {
  background: rgba(229, 0, 0, 0.1);
  color: #E50000;
}

.Links_resetButton__LcYuY:hover {
  background: rgba(229, 0, 0, 0.2);
}

.Links_urlInput__Kbqa5 {
  width: 100%;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #fff;
  font-family: 'Manrope', sans-serif;
}

.Links_urlInput__Kbqa5:focus {
  outline: none;
  border-color: #E50000;
}

@media (max-width: 768px) {
  .Links_headerContent__WelKd {
    padding: 60px 1rem 0;
  }

  .Links_mainContainer__VeVwH {
    padding: 0 1rem;
  }

  .Links_grid__-hrzq {
    grid-template-columns: 1fr;
  }

  .Links_title__SlbNS {
    font-size: 1.75rem;
  }

  .Links_cardActions__C4t7S {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/Links.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,UAAU;EACV,2BAA2B;EAC3B,mDAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAyB,qBAAqB,EAAE;AAChD,sCAAyB,qBAAqB,EAAE;AAChD,sCAAyB,qBAAqB,EAAE;AAChD,sCAAyB,qBAAqB,EAAE;AAChD,sCAAyB,qBAAqB,EAAE;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap');\n\n.pageContainer {\n  min-height: 100vh;\n  background-color: #1F1D1D;\n  color: #fff;\n  font-family: 'Manrope', sans-serif;\n}\n\n.headerSection {\n  width: 100%;\n  background-color: #1F1D1D;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.headerContent {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 100px 2rem 0;\n}\n\n.headerTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  padding: 0.75rem 1.25rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: 'Manrope', sans-serif;\n  width: fit-content;\n}\n\n.backButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.mainContainer {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 0 2rem;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 16px;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n  opacity: 0;\n  transform: translateY(20px);\n  animation: fadeInUp 0.5s ease forwards;\n}\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.grid > *:nth-child(1) { animation-delay: 0.1s; }\n.grid > *:nth-child(2) { animation-delay: 0.2s; }\n.grid > *:nth-child(3) { animation-delay: 0.3s; }\n.grid > *:nth-child(4) { animation-delay: 0.4s; }\n.grid > *:nth-child(5) { animation-delay: 0.5s; }\n\n.cardHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.icon {\n  color: #E50000;\n}\n\n.platformName {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.url {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  font-size: 0.9rem;\n  word-break: break-all;\n}\n\n.url:hover {\n  color: #fff;\n}\n\n.cardActions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: auto;\n}\n\n.editButton,\n.resetButton {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-family: 'Manrope', sans-serif;\n  transition: all 0.2s ease;\n}\n\n.editButton {\n  background: rgba(255, 255, 255, 0.05);\n  color: #fff;\n}\n\n.editButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.resetButton {\n  background: rgba(229, 0, 0, 0.1);\n  color: #E50000;\n}\n\n.resetButton:hover {\n  background: rgba(229, 0, 0, 0.2);\n}\n\n.urlInput {\n  width: 100%;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #fff;\n  font-family: 'Manrope', sans-serif;\n}\n\n.urlInput:focus {\n  outline: none;\n  border-color: #E50000;\n}\n\n@media (max-width: 768px) {\n  .headerContent {\n    padding: 60px 1rem 0;\n  }\n\n  .mainContainer {\n    padding: 0 1rem;\n  }\n\n  .grid {\n    grid-template-columns: 1fr;\n  }\n\n  .title {\n    font-size: 1.75rem;\n  }\n\n  .cardActions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Links_pageContainer__jCNjv`,
	"headerSection": `Links_headerSection__8evuI`,
	"headerContent": `Links_headerContent__WelKd`,
	"headerTop": `Links_headerTop__CunUv`,
	"backButton": `Links_backButton__rweU-`,
	"title": `Links_title__SlbNS`,
	"mainContainer": `Links_mainContainer__VeVwH`,
	"grid": `Links_grid__-hrzq`,
	"card": `Links_card__ww32g`,
	"fadeInUp": `Links_fadeInUp__FmB9U`,
	"cardHeader": `Links_cardHeader__6QeYk`,
	"icon": `Links_icon__kKFo4`,
	"platformName": `Links_platformName__RI7TU`,
	"url": `Links_url__NCx-V`,
	"cardActions": `Links_cardActions__C4t7S`,
	"editButton": `Links_editButton__Hpdyp`,
	"resetButton": `Links_resetButton__LcYuY`,
	"urlInput": `Links_urlInput__Kbqa5`
};
export default ___CSS_LOADER_EXPORT___;
